'use client'

export function AnimatedGradient() {
  // Static gradient - mouse tracking removed to fix 100% CPU usage issue
  return (
    <div
      className="fixed inset-0 -z-10 bg-gradient-to-br from-blue-50 via-white to-purple-50"
      style={{
        background: 'radial-gradient(at 30% 40%, rgb(219 234 254) 0%, rgb(243 244 246) 50%, rgb(243 232 255) 100%)'
      }}
    />
  )
}
